export default __webpack_public_path__ + "static/media/childVoiceOverBackground.0bfd3680.jpg";